<div class="request-for-approvals-container">

    <!-- <div class="divider"></div> -->
    <div class="request-for-approvals-body" fxLayout="column">

        <ng-container *ngIf="emptyAttendanceDataRequest && emptyLeaveDataRequest && emptyCarDataRequest && emptyAccommodationDataRequest 
            && !attendanceRequestLoading && !leaveRequestLoading && !carRequestLoading && !accommodationRequestLoading && !remindersLoadingData && !remindersData?.length 
            && !synergyLoadingData && !synergyApprovals?.length">
            <div class="empty-data" fxFlex="100" fxLayout="column" fxLayoutAlign="center center">
                <div>
                    <img height="80"
                        [src]="EmptyState"
                        alt="Empty">
                </div>
                <span>No Pending Requests found.</span>
            </div>
        </ng-container>
        <ng-container *ngIf="attendanceRequestLoading">
            <div fxFlex="100" fxLayout="column">
                <div class="request-list-container">
                    <div class="shimmer-wrapper">
                        <div class="shimmer-card">
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <approval [approvalData]="reqForAttendanceApprovalsData"
            (fetchRequest)="fetchAttendanceRequestForApprovalData()"></approval>

        <ng-container *ngIf="accommodationRequestLoading">
            <div fxFlex="100" fxLayout="column">
                <div class="request-list-container">
                    <div class="shimmer-wrapper">
                        <div class="shimmer-card">
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <approval [approvalData]="reqForAccommodationApprovalData"
            (fetchRequest)="fetchAccommodationRequestForApprovalData()"></approval>

        <ng-container *ngIf="carRequestLoading">
            <div fxFlex="100" fxLayout="column">
                <div class="request-list-container">
                    <div class="shimmer-wrapper">
                        <div class="shimmer-card">
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <approval [approvalData]="reqForCarApprovalData" (fetchRequest)="fetchCarRequestForApprovalData()"></approval>

        <ng-container *ngIf="leaveRequestLoading">
            <div fxFlex="100" fxLayout="column">
                <div class="request-list-container">
                    <div class="shimmer-wrapper">
                        <div class="shimmer-card">
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <approval [approvalData]="reqForLeaveApprovalData" (fetchRequest)="fetchLeaveRequestForApprovalData()">
        </approval>

        <ng-container *ngIf="synergyLoadingData">
            <div fxFlex="100" fxLayout="column">
                <div class="request-list-container">
                    <div class="shimmer-wrapper">
                        <div class="shimmer-card">
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <approval *ngIf="isSynergyApprover && !synergyLoadingData && synergyApprovals?.length"
            [approvalData]="synergyApprovals" (fetchRequest)="fetchSynergyRequestForApprovalData()">
        </approval>

        <ltts-reminders [reminders]="remindersData" [remindersLoading]="remindersLoadingData"></ltts-reminders>
    </div>
</div>